module.exports = __webpack_public_path__ + "img/cjmb.edda91cd.png";